import { BaseDto } from 'src/dtos/common/baseDto';

/**
 * 교육 수료증 첨부(hrm_training_file) 행과 화면 편집 상태이다.
 * file_data(bytea)는 사용하지 않는 컬럼이라 API로 주고받지 않는다.
 */
export interface HrmTrainingFileDto extends BaseDto {
    empNo: string; // 사원번호
    trainSeq: number | null; // 첨부 대상 교육 순번. 신규 교육의 첨부는 null
    fileSeq: number | null; // 교육별 파일 순번, 신규는 null (서버 채번)
    fileNm: string; // 확장자를 포함한 원본 파일명
    fileType: string; // MIME 형식 (image/png, application/pdf 등)
    fileSize: number; // 파일 크기(byte)
    filePath: string; // 공통 파일ID(mst_file.file_id). 다운로드·삭제 키
    remark: string; // 첨부 비고
    inserted: boolean; // 저장되지 않은 첨부이면 true
    isModified: boolean; // 조회 후 비고를 수정했으면 true
}

/** 첨부 신규 행의 기본값이다. */
export const defaultHrmTrainingFileDto: HrmTrainingFileDto = {
    valueIndex: 0, orderIndex: 0, orderIndexSeq: 0,
    empNo: '', trainSeq: null, fileSeq: null, fileNm: '', fileType: '', fileSize: 0,
    filePath: '', remark: '', inserted: false, isModified: false,
};
